const CacheStore = {
  state: {
    alerts: null,
    home: null
  },

  mutations: {
    cache (state, opts) {
      state[opts.name] = opts.item
    }
  },

  actions: {
    getCache (module, opts) {
      if (!module.state[opts.name]) {
        return opts.fallback()
      }
      return Promise.resolve(module.state[opts.name])
    },
    // this.$store.dispatch('invalidateCache', 'alerts');
    invalidateCache (module, name) {
      module.state[name] = null
    }
  },

  getters: {}
}

export default CacheStore
